var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAlignRightIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 10",
    fill: "white",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.77952 1.25H0.220485C0.0987142 1.25 0 1.34871 0 1.47049V1.96701C0 2.08879 0.0987142 2.1875 0.220485 2.1875H9.77952C9.90129 2.1875 10 2.08879 10 1.96701V1.47049C10 1.34871 9.90129 1.25 9.77952 1.25Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.77952 7.8125H0.220485C0.0987142 7.8125 0 7.91122 0 8.03299V8.52951C0 8.65128 0.0987142 8.75 0.220485 8.75H9.77952C9.90129 8.75 10 8.65128 10 8.52951V8.03299C10 7.91122 9.90129 7.8125 9.77952 7.8125Z",
    fill: "current"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.07014 2.8125H5.30486C5.13649 2.8125 5 2.94899 5 3.11736V6.88264C5 7.05101 5.13649 7.1875 5.30486 7.1875H9.07014C9.23851 7.1875 9.375 7.05101 9.375 6.88264V3.11736C9.375 2.94899 9.23851 2.8125 9.07014 2.8125Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlignRightIcon);
export default __webpack_public_path__ + "static/media/AlignRightIcon.bbca33f05e390229a60ccde4f0f7d2dc.svg";
export { ForwardRef as ReactComponent };